export default "__VITE_ASSET__BDNAexPd__"